import { render } from "./project_setting.vue?vue&type=template&id=a964a67a&scoped=true"
import script from "./project_setting.vue?vue&type=script&lang=js"
export * from "./project_setting.vue?vue&type=script&lang=js"

import "./project_setting.vue?vue&type=style&index=0&id=a964a67a&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a964a67a"]])

export default __exports__